module.exports = __webpack_public_path__ + "img/help_safari3,4.4f6f6c41.png";